"use client";
import dynamic from "next/dynamic";
import 'react-international-phone/style.css';

const PhoneInput = dynamic(() => import('react-international-phone').then(mod => mod.PhoneInput), { ssr: false });

export default PhoneInput;
